module.exports = __webpack_public_path__ + "static/media/footer-vigilado.01470807.svg";